import { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col, Image,  } from 'react-bootstrap';
import NearByGrid from "../../components/common/nearByGrid";
import SoftwareProviders from "../../assests/images/partner-solutions-image/software-providers.webp";
import {
    PartnerSolutionsSection,
    PartnerSection,
    SolutionWrap,
    SolutionBox,
    SolutionBoxTitle,
    SolutionBoxSpan,
    SolutionDetailBox,
    SolutionDetailImageWrap,
    SolutionDetailImage,
    SolutionDetailContent,
    SolutionDetailTitle,
    ClientsListWrap,
    ClientsListBox,
    PeopleServedBox,
    PeopleServedTitle,
    PeopleServedText,
    FundersListBox,
} from "./partnerSolutionsStyle";
import { AdvocacyTitle, ElliottAdvocacyBanner } from "../../components/common/commonSubPageBanner/commonSubPageBannerStyle";
import { useSelector,useDispatch } from "react-redux";
import { clientsHandler } from "../../redux/slices/sponsors/client-slice";
import { fundersHandler } from "../../redux/slices/sponsors/funders-slice";
import { solutionsHandler } from "../../redux/slices/solutions/solutions-slice";
import { MESSAGE } from "../../utils/message";
import MetaComponent from "../../components/common/metaComponent";

const PartnerSolutions = () => {
    const [selectedClients,setSelectedClients] = useState('');
    const [selectedFunders,setSelectedFunders] = useState('');
    const dispatch: any = useDispatch();
    const clientsList = useSelector((state:any) => state?.clients?.data?.data);
    const fundersList = useSelector((state:any) => state?.funders?.data?.data);
    const sponsorsList = useSelector((state:any) => state?.solution?.data)

    useEffect(() =>{
        dispatch(fundersHandler());
        dispatch(clientsHandler());
        dispatch(solutionsHandler())
    },[])

    return (
        <>
         <MetaComponent 
            keywords=""
            description="Extend your reach, build &amp; engage your community with our partnership tools including our API, Marketing and Advertising opportunities."
            ogTitle="Partner Solutions | GreatNonprofits"
            ogDescription="Extend your reach, build &amp; engage your community with our partnership tools including our API, Marketing and Advertising opportunities."
            ogUrl="https://www.about.greatnonprofits.org/partner-solutions"
            ogImage="https://static.wixstatic.com/media/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg/v1/fit/w_2500,h_1330,al_c/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg"
        />
        <>
        <PartnerSolutionsSection>
            <ElliottAdvocacyBanner>
                <Container className="cont-w">
                    <AdvocacyTitle className='title-sub-page'>{MESSAGE.partnerSolutions}</AdvocacyTitle>
                </Container>
            </ElliottAdvocacyBanner>
        </PartnerSolutionsSection>

        <PartnerSection> 
            <Container className="cont-w">
                <Row className="partner-section-main">
                    <Col md="9">
                        <SolutionWrap>
                        {sponsorsList?.data?.map((sponsor:any, index:number) => (
                            <SolutionBox key={index+1}>
                                <SolutionBoxTitle>{sponsor.solutionFor}<SolutionBoxSpan>- {sponsor.solutionDesc}</SolutionBoxSpan></SolutionBoxTitle>

                                <SolutionDetailBox>
                                    <SolutionDetailImageWrap>
                                        <SolutionDetailImage>
                                            <Image src={SoftwareProviders} alt="software providers" />
                                        </SolutionDetailImage>

                                        <SolutionDetailTitle>{sponsor.title}</SolutionDetailTitle>

                                    </SolutionDetailImageWrap>
                                    <SolutionDetailContent>{sponsor.detail}</SolutionDetailContent>
                                </SolutionDetailBox>

                            </SolutionBox>
                        ))}
                        </SolutionWrap>
                    </Col>
                    <Col md="3">
                        <ClientsListWrap>
                            <ClientsListBox>
                                <NearByGrid listData={clientsList} title={MESSAGE.clients} selectedClients={selectedClients} setData={setSelectedClients}/>
                            </ClientsListBox>

                            <PeopleServedBox>
                                <PeopleServedTitle>{MESSAGE.peopleServed}</PeopleServedTitle>
                                <PeopleServedText>20,000 Nonprofits</PeopleServedText>
                                <PeopleServedText>200,000 Volunteers & Donors</PeopleServedText>
                            </PeopleServedBox>

                            <FundersListBox>
                                <NearByGrid listData={fundersList} title={MESSAGE.funders} selectedFunders={selectedFunders} setData={setSelectedFunders}/>
                            </FundersListBox>

                        </ClientsListWrap>
                    </Col>
                </Row>
            </Container>
        </PartnerSection>
    </>
        </>
    )
};
export default PartnerSolutions;